import { navigation } from './stores';

/**
 * Navigate to take survey page
 */
export const navigateToTakeSurveyPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'Take';
        n.takeMode = 'Standard';

        return n;
    });
};

/**
 * Navigate to preview survey page. Almost same functionality as take survey, but answer will not be saved.
 * @param {Boolean} hideEditButton Set this to true, to hide the "Edit question" button when e.g. there are global answers
 */
export const navigateToPreviewSurveyPage = (hideEditButton) => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'Take';
        n.takeMode = 'Preview';
        n.hideEditButton = hideEditButton;

        return n;
    });
};

/**
 * Navigate to print survey page.
 */
export const navigateToPrintSurveyPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'Print';

        return n;
    });
};

/**
 * Navigate to edit question page
 * @param {String} type   "MultipleChoice"
 * @param {Number} questionId
 */
export const navigateToEditQuestionPage = (type, questionId = null) => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'EditQuestion';
        n.questionType = type;
        n.questionId = questionId;

        return n;
    });
};

/**
 * Navigate to view survey page
 */
export const navigateToViewSurveyPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'View';
        n.viewTabId = 'tabSurvey';

        return n;
    });
};

/**
 * Navigate to view answer page
 * @param {Number} answerId
 * @param {Number} returnTab
 */
export const navigateToViewAnswerPage = (answerId, returnTab = 'tabResults') => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'ViewAnswer';
        n.viewTabId = returnTab;
        n.answerId = answerId;

        return n;
    });
};

/**
 * Navigate to edit survey page
 * @param {Boolean} addToBrowserHistory
 */
export const navigateToEditSurveyPage = (addToBrowserHistory = true) => {
    navigation.update((n) => {
        if (addToBrowserHistory) {
            pushState(n);
        }

        n.page = 'Edit';
        n.viewTabId = 'tabSurvey';

        return n;
    });
};

/**
 * Navigate to question list page
 */
export const navigateToQuestionListPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'View';
        n.viewTabId = 'tabQuestions';
        n.takeMode = 'Standard';

        return n;
    });
};

/**
 * Navigate to results page
 */
export const navigateToResultsPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'View';
        n.viewTabId = 'tabResults';

        return n;
    });
};

/**
 *  Navigate to completed survey page
 */
export const navigateToCompletedSurveyPage = () => {
    navigation.update((n) => {
        pushState(n);
        n.page = 'Completed';

        return n;
    });
};

function pushState(nav) {
    // window.history.pushState({...nav}, nav.page);
}
